<template>
  <div class="parking-status-label">
    <v-chip
      v-if="parking.status === 'confirmed'"
      color="success"
      label
      :small="small"
      :large="large"
    >
      Bestätigt
    </v-chip>
    <v-chip
      v-else-if="parking.status === 'canceled'"
      color="danger"
      label
      :small="small"
      :large="large"
    >
      Storniert
    </v-chip>
    <v-chip v-else color="warning" label :small="small" :large="large">
      In Bearbeitung
    </v-chip>
  </div>
</template>

<script>
export default {
  props: {
    parking: {
      type: Object,
      required: true
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style></style>
